import React from "react";
import { Typography } from "@material-ui/core";
import DPHelpTooltip from "Components/DP/DPHelpTooltip/DPHelpTooltip";
import pretty from "Shared/pretty";

interface FeeTooltipProps {
  cycleDpaFeeCents: number;
  cycleUserBankFeeCents: number;
}

export const FeeTooltip = ({ cycleDpaFeeCents, cycleUserBankFeeCents}: FeeTooltipProps) => {

  return (
    <DPHelpTooltip
      title={(
        <Typography>
          {pretty.dollar(cycleDpaFeeCents)} for DailyPay Account,&thinsp;
          {pretty.dollar(cycleUserBankFeeCents)} for other accounts
        </Typography>
      )}
    />
  );
};
